<div class="cbc-local-file-required-dialog">
  <div class="cbc-local-file-required-default">
    <span>Default Value: &nbsp;&nbsp;&nbsp; {{cbcLocalFileRequiredDefaultValue}}</span>
  </div>

  <div class="cbc-local-file-required-overwrite">
    <mat-checkbox [(ngModel)]="LocalFileRequiredOverwrite">Overwrite</mat-checkbox>
    <mat-radio-group class="overwrite-options" [(ngModel)]="overwrittenCellValue">
      <mat-radio-button class="overwrite-option-value" [disabled]="!LocalFileRequiredOverwrite"  value="Yes">Yes</mat-radio-button>
      <mat-radio-button class="overwrite-option-value" [disabled]="!LocalFileRequiredOverwrite"  value="No">No</mat-radio-button>
    </mat-radio-group>
  </div>
</div>
